import React, { forwardRef } from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RTextAreaProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    minRows?: number;
    resize?: boolean;
    maxLength?: number;
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

export const RTextArea = forwardRef<HTMLTextAreaElement, RTextAreaProps>(function RTextArea(
    { value, onChange, placeholder, disabled, fullWidth, minRows = 4, resize = true, maxLength, onKeyDown },
    ref,
) {
    return (
        <StyledTextArea
            ref={ref}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            disabled={disabled}
            fullWidth={fullWidth}
            rows={minRows}
            maxLength={maxLength}
            style={resize ? undefined : { resize: 'none' }}
        />
    );
});

const StyledTextArea = styled('textarea')<{ fullWidth?: boolean }>(({ fullWidth }) => ({
    width: fullWidth ? '100%' : 'auto',
    padding: '10px 14px',
    fontSize: 14,
    color: Colors.darkNavy,
    backgroundColor: Colors.faintGrey,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    outline: 'none',
    boxSizing: 'border-box',
    resize: 'vertical',
    lineHeight: 1.5,
    '&:focus': {
        borderColor: Colors.mediumGrey,
    },
    '&:disabled': {
        backgroundColor: Colors.fill,
        color: Colors.mediumGrey,
    },
    '&::placeholder': {
        color: Colors.lightGrey,
    },
}));
